import { render } from "./CustomerVehicles.html?vue&type=template&id=2a2b4dbb&scoped=true"
import script from "./CustomerVehicles.js?vue&type=script&lang=js"
export * from "./CustomerVehicles.js?vue&type=script&lang=js"

import "./CustomerVehicles.css?vue&type=style&index=0&id=2a2b4dbb&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a2b4dbb"]])

export default __exports__